module.exports = __webpack_public_path__ + "static/media/dentalblur.a20a120b.png";